module.exports = __webpack_public_path__ + "img/instagram.d139c3af.svg";